// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2NjG0","head":"Table_head__UUso5","col":"Table_col__2dS5e"};